"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.results.title': 'Training Results',
    'trainer.results.success': 'Training Completed Successfully!',
    'trainer.results.success.message': 'Your custom model {modelName} has been trained and is ready for use.',
    'trainer.results.metrics': 'Final Performance Metrics',
    'trainer.results.metric.loss': 'Final Loss',
    'trainer.results.metric.accuracy': 'Final Accuracy',
    'trainer.results.metric.epochs': 'Epochs Completed',
    'trainer.results.metric.samples': 'Training Samples',
    'trainer.results.export': 'Export Model',
    'trainer.results.deploy': 'Deploy Model',
    'trainer.results.test': 'Test Model',
};
